import "./OTPForm.css";
import { BottomSection } from "../../BottomSection/BottomSection";
import { TopSection } from "../../TopSection/TopSection";
import { useForm } from "react-hook-form";
import axios from "axios";
import { useState } from "react";

export const OTPForm = ({userData,setRegistrationStep,isRegisterationTrue,setForgotPasswordStep,setAuthToken}) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const [error ,setErrors] = useState('');
  const [loading,setLoading] = useState(false);
  const onSubmit = (data) => {
    console.log("otp data",data)
      setLoading(true);
      axios.post('https://mfnj3t4tqm.us-east-1.awsapprunner.com/api/uloggedin/user/verify-otp',
        {
          phoneNumber : userData?.mobileNumber,
          otp:data?.otp
        }
      )
      .then((resp)=>{
        console.log(resp.data)
        setLoading(false);
        setAuthToken(resp?.data?.token)
        if(isRegisterationTrue){
          setRegistrationStep(2)
        }
        else{
          setForgotPasswordStep(2)
        }
      })
      .catch((err)=>{
        setLoading(false);
        console.log("err",err?.response?.data)
        setErrors(err?.response?.data?.message);
        setTimeout(()=>{
          setErrors('')
        },2000)
      })
    
  };

  console.log(watch("example")); // watch input value by passing the name of it
  return (
    <>
      <div className="otp-form-container">
        <TopSection />
        <form className="otp-middle-section" onSubmit={handleSubmit(onSubmit)}>
          <h2>OTP Submission</h2>
          <hr />
          <input
            type="text"
            id="otp"
            name="otp"
            placeholder="OTP"
            {...register("otp", { required: true })}
            className={`input-field ${errors.otp ? "error-para" : ""}`}
          />
          <button className="submit-btn" type="submit">
            {loading?'Loading...':'Submit'}
          </button>
          {
            error &&
            <p style={{marginTop:10,fontSize:13,color:'red'}}>{error}</p>
          }
          <BottomSection />
        </form>
      </div>
    </>
  );
};
